import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '@/contexts/StoreContext';
import { temPaginaDeJogadores } from '@/lib/services/players-online.service';

/** A contagem de online leva à página Jogadores, quando a loja tem a página ligada. */
export function LinkDosJogadores({ children, className }: { children: ReactNode; className?: string }) {
  const { store } = useStore();
  if (!temPaginaDeJogadores(store)) return <>{children}</>;
  return (
    <Link to="/jogadores" className={className ?? 'hover:underline'} data-testid="link-jogadores">
      {children}
    </Link>
  );
}
